var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"account-change-password"},[_c('edit',{attrs:{"fs":_vm.userChangePasswordFields,"apiSave":"users/password:put","customClassName":"none","title":"Change Password"},on:{"saved":_vm.saved}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }